import Component from "./scrollLesson.component";
import { Config } from "./scrollLesson.config";
import { watchScrollLesson as saga } from "./redux/scrollLesson.sagas";
import { reducer } from "./redux/scrollLesson.reducer";

export default { Component, saga, reducer, config: Config };
